import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Loader = () => (
  <div className="min-h-screen grid place-items-center text-muted-foreground font-mono text-sm">Loading…</div>
);

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return user ? children : <Navigate to="/admin" replace />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return user ? <Navigate to="/admin/dashboard" replace /> : <AdminLogin />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<LoginRoute />} />
          <Route path="/admin/dashboard" element={<Protected><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" richColors />
    </AuthProvider>
  );
}

export default App;
